import { render } from "./LbrxTellerConsole.vue?vue&type=template&id=525c6362&scoped=true"
import script from "./LbrxTellerConsole.vue?vue&type=script&lang=js"
export * from "./LbrxTellerConsole.vue?vue&type=script&lang=js"

import "./LbrxTellerConsole.vue?vue&type=style&index=0&id=525c6362&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525c6362"]])

export default __exports__